import { ESTACIO_INICIALITZAR,
    ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES,
    ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS,
    ESTACIO_INTRODUCCIO_VARIABLES_MODIFICAR_VARIABLE_MOMENT
} from '../../../../actions/actionTypes';

export const ESTAT_INICIAL = {
    originals: [],
    editades: []
};

const variablesMoments = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES:
            return {
                originals: action.estructuraIDades.dades.variablesMoments,
                editades: action.estructuraIDades.dades.variablesMoments
            };

        case ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS:
            return {
                ...state,
                editades: state.originals
            };

        case ESTACIO_INTRODUCCIO_VARIABLES_MODIFICAR_VARIABLE_MOMENT: {
            const { idVariableMoment, estaVariableMomentActiva } = action;

            let editadesModificat = [...state.editades];

            if (estaVariableMomentActiva && !state.editades.includes(idVariableMoment)) {
                editadesModificat.push(idVariableMoment);
            } else if (!estaVariableMomentActiva) {
                editadesModificat = state.editades.filter(id => id !== idVariableMoment);
            }

            return {
                ...state,
                editades: editadesModificat
            };

        }

        default:
            return state;
    }
};

export default variablesMoments;



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/dades/variablesMoments.js